import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MARKET, pickMarketRows } from "@/lib/market";
import { PT_PUBLIC_CONTACT, publicCompanyIdentity } from "@/lib/publicCompanyIdentity";

/** Shared public source for contact page, footer, legal identity and SEO. */
export function usePublicContactSettings() {
  const query = useQuery({
    queryKey: ["contact-settings", MARKET],
    queryFn: async () => {
      const { data, error } = await supabase.from("contact_settings")
        .select("setting_key, setting_value, market").eq("market", MARKET);
      if (error) throw error;
      const settings: Record<string, string> = MARKET === "pt" ? { ...PT_PUBLIC_CONTACT } : {};
      pickMarketRows(data, MARKET).forEach(row => { settings[row.setting_key] = row.setting_value; });
      return settings;
    },
  });
  return { ...query, identity: publicCompanyIdentity(MARKET === "pt" ? query.data : undefined) };
}